const EXPLAINER_NAMES = {
  EXPLAIN_ADDITIONAL_PEOPLE: 'explainAdditionalPeople', // Deprecated
  EXPLAIN_PRIMARY_DRIVER: 'explainPrimaryDriver', // Deprecated
  EXPLAIN_INCIDENTS: 'explainIncidents', // Deprecated
  TEXT_ALERT_CONSENT: 'textAlertConsent'
};

const PROMPT_NAMES = {
  ZIP_CODE: 'zipCode',
  COVERAGE_TYPE: 'coverageType',
  ADDRESS: 'address',
  EFFECTIVE_DATE: 'effectiveDate',
  AUTO_EFFECTIVE_DATE: 'autoEffectiveDate',
  PROPERTY_TYPE: 'propertyType',
  PROPERTY_USAGE: 'propertyUsage',
  MOVE_IN_DATE: 'moveInDate',
  PROPERTY_PURCHASE_DATE: 'propertyPurchaseDate',
  PRIMARY_RESIDENCE_ADDRESS: 'primaryResidenceAddress', // Asked when insuring a home that is rented to others
  CURRENT_AUTO_INSURER: 'currentAutoInsurer',
  CURRENT_CONDO_INSURER: 'currentCondoInsurer',
  CURRENT_HOME_INSURER: 'currentHomeInsurer',
  CURRENT_RENTERS_INSURER: 'currentRentersInsurer',
  UNDERGROUND_FUEL_TANK: 'undergroundFuelTank',
  BURGLAR_ALARM: 'burglarAlarm',
  FIRE_ALARM: 'fireAlarm',
  PROPERTY_DISCOUNTS: 'propertyDiscounts',
  MARITAL_STATUS: 'maritalStatus',
  DOG_BREED: 'dogBreed',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  DOB: 'dob',
  GENDER: 'gender',
  PHONE: 'phone',
  PHONE_TYPE: 'phoneType',
  TAX_ID: 'taxId',
  JOB_INDUSTRY: 'jobIndustry',
  ROLE: 'role',
  DEFENSIVE: 'defensive',
  DRIVING_MONITOR: 'drivingMonitor',
  VEHICLE_YEAR: 'vehicleYear',
  VEHICLE_MAKE: 'vehicleMake',
  VEHICLE_MODEL: 'vehicleModel',
  VEHICLE_SUBMODEL: 'vehicleSubmodel',
  VEHICLE_USE: 'vehicleUse',
  VEHICLE_ACTIVITIES: 'vehicleActivities',
  VEHICLE_OWNERSHIP_STATUS: 'vehicleOwnershipStatus',
  ANNUAL_MILES: 'annualMiles',
  GPA: 'gpa',
  OTHERS_ON_POLICY: 'othersOnPolicy',
  ANIMALS: 'animals',
  ANIMAL_INJURY: 'animalInjury',
  ALREADY_OWN_PROPERTY: 'alreadyOwnProperty',
  SQ_FOOTAGE: 'sqFootage',
  NUM_OF_MORTGAGES: 'numOfMortgages',
  UNIT_NUMBER: 'unitNumber',
  RELATIONSHIP: 'relationship', // Deprecated. Use relationshipToInsured.
  LOAN_AMOUNT: 'loanAmount',
  RECENT_AUTO_CLAIM: 'recentAutoClaim',
  RECENT_CONDO_CLAIM: 'recentCondoClaim',
  RECENT_HOME_CLAIM: 'recentHomeClaim',
  RECENT_RENTERS_CLAIM: 'recentRentersClaim',
  AUTO_POLICY_CANCELED: 'autoPolicyCanceled',
  CONDO_POLICY_CANCELED: 'condoPolicyCanceled',
  HOME_POLICY_CANCELED: 'homePolicyCanceled',
  RENTERS_POLICY_CANCELED: 'rentersPolicyCanceled',
  YEARS_AUTO_INSURED: 'yearsAutoInsured',
  YEARS_CONDO_INSURED: 'yearsCondoInsured',
  YEARS_HOME_INSURED: 'yearsHomeInsured',
  YEARS_RENTERS_INSURED: 'yearsRentersInsured',
  YEARS_CONTINUOUSLY_CONDO_INSURED: 'yearsContinuouslyCondoInsured',
  YEARS_CONTINUOUSLY_HOME_INSURED: 'yearsContinuouslyHomeInsured',
  YEARS_CONTINUOUSLY_RENTERS_INSURED: 'yearsContinuouslyRentersInsured',
  YEARS_CONTINUOUSLY_AUTO_INSURED: 'yearsContinuouslyAutoInsured',
  CURRENT_AUTO_POLICY_EXPIRATION: 'currentAutoPolicyExpiration',
  CURRENT_CONDO_POLICY_EXPIRATION: 'currentCondoPolicyExpiration',
  CURRENT_HOME_POLICY_EXPIRATION: 'currentHomePolicyExpiration',
  CURRENT_RENTERS_POLICY_EXPIRATION: 'currentRentersPolicyExpiration',
  CURRENT_AUTO_POLICY_EFFECTIVE: 'currentAutoPolicyEffective',
  CURRENT_CONDO_POLICY_EFFECTIVE: 'currentCondoPolicyEffective',
  CURRENT_HOME_POLICY_EFFECTIVE: 'currentHomePolicyEffective',
  CURRENT_RENTERS_POLICY_EFFECTIVE: 'currentRentersPolicyEffective',
  MARRIED: 'married',
  EDUCATION: 'education',
  LICENSE_STATUS: 'licenseStatus',
  LICENSE_DATE: 'licenseDate',
  ASSIGNED_DRIVER: 'assignedDriver',
  RESIDENCE_TYPE: 'residenceType',
  LIVED_AT_PRIMARY_ADDRESS: 'livedAtPrimaryAddress',
  PARKED_AT_PRIMARY_ADDRESS: 'parkedAtPrimaryAddress',
  CAR_ADDRESS: 'carAddress',
  LICENSE_SUSPENDED: 'licenseSuspended',
  DRIVERS_LICENSE_NUMBER: 'driversLicenseNumber',
  DRIVERS_LICENSE_STATE: 'driversLicenseState',
  VIN: 'vin',
  DRIVING_COURSE_DATE: 'drivingCourseDate',
  FLOOR_NUMBER: 'floorNumber',
  PRIOR_ADDRESS: 'priorAddress',
  PLUMBING_TYPE: 'plumbingType',
  HAS_BUSINESS: 'hasBusiness',
  BUSINESS_NAME: 'businessName',
  BUSINESS_TYPE: 'businessType',
  INCIDENT_TYPE: 'incidentType',
  INCIDENT_DRIVER: 'incidentDriver',
  INCIDENT_DATE: 'incidentDate',
  INCIDENT_DESCRIPTION: 'incidentDescription',
  INCIDENT_AMOUNT: 'incidentAmount',
  NAME: 'name',
  NUM_OF_RESIDENTS: 'numOfResidents',
  NUM_OF_CHILDREN: 'numOfChildren',
  YEAR_BUILT: 'yearBuilt',
  YEAR_ROOF_UPDATED: 'yearRoofUpdated',
  ROOF_UPDATE_TYPE: 'roofUpdateType',
  YEAR_HEATING_UPDATED: 'yearHeatingUpdated',
  HEATING_UPDATE_TYPE: 'heatingUpdateType',
  YEAR_PLUMBING_UPDATED: 'yearPlumbingUpdated',
  PLUMBING_UPDATE_TYPE: 'plumbingUpdateType',
  YEAR_ELECTRIC_UPDATED: 'yearElectricUpdated',
  ELECTRIC_UPDATE_TYPE: 'electricUpdateType',
  NUM_OF_CHILDREN_NON_DRIVERS: 'numOfChildrenNonDrivers',
  RELATIONSHIP_TO_INSURED: 'relationshipToInsured',
  VEHICLE_PURCHASE_DATE: 'vehiclePurchaseDate',
  VEHICLE_FINANCING_COMPANY: 'vehicleFinancingCompany',
  ADDITIONAL_DRIVER_USAGE: 'additionalDriverUsage',
  ALERT_PREFERENCE: 'alertPreference',
  CONDO_MASTER_POLICY: 'condoMasterPolicy',
  COMMENTS: 'comments',
  OWN_OTHER_PROPERTIES: 'ownOtherProperties',
  OWN_OTHER_VEHICLES: 'ownOtherVehicles',
  OTHER_VEHICLES_INSURED: 'otherVehiclesInsured',
  OTHER_VEHICLES_INSURANCE_COMPANIES: 'otherVehiclesInsuranceCompanies',
  INCLUDE_UNINSURED_COVERAGE: 'includeUninsuredCoverage',
  EXCLUSION_REASON: 'exclusionReason',
  INTERESTED_IN_PROPERTY: 'interestedInProperty',
  FEEDBACK: 'feedback'
};

const PROMPT_NAME_VALUES = Object.values(PROMPT_NAMES);

const PROMPT_GROUP_NAMES = {
  DRIVERS: 'Driver',
  VEHICLES: 'Vehicle',
  EXCLUDED_DRIVERS: 'ExcludedDrivers',
  PERSON: 'Person',
  INCIDENTS: 'Incident',
  PROPERTY_INCIDENT: 'Claim',
  TRADE_INS: 'tradeIns',
  DESIRED_VEHICLES: 'desiredVehicles'
};

const PROMPT_GROUP_NAME_VALUES = Object.values(PROMPT_GROUP_NAMES);

module.exports = {
  EXPLAINER_NAMES,
  PROMPT_NAMES,
  PROMPT_NAME_VALUES,
  PROMPT_GROUP_NAMES,
  PROMPT_GROUP_NAME_VALUES
};
